module.exports = __webpack_public_path__ + "img/text_align_left.6c63858f.svg";